import { SxProps, Theme } from '@mui/material/styles'

export const alertHoverStyles = {
  popover: {
    pointerEvents: 'none',
    '& .MuiPaper-root': {
      borderRadius: 1,
      boxShadow: '0px 1px 4px rgba(30, 32, 38, 0.16)',
    },
  } as SxProps<Theme>,

  /** Horizontal single-row card for most alert types */
  inlineCard: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    padding: 1.5,
    backgroundColor: 'common.white',
    borderRadius: 1,
    boxShadow: '0px 1px 4px rgba(30, 32, 38, 0.16)',
    minWidth: 200,
    pointerEvents: 'auto',
  } as SxProps<Theme>,

  /** Expanded card for packages (header + body table) */
  expandedCard: {
    width: 300,
    padding: 2,
    backgroundColor: 'common.white',
    borderRadius: 1,
    boxShadow: '0px 1px 4px rgba(30, 32, 38, 0.16)',
    pointerEvents: 'auto',
  } as SxProps<Theme>,

  expandedHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
  } as SxProps<Theme>,

  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    minWidth: 0,
  } as SxProps<Theme>,

  /** @deprecated Use inlineCard / expandedCard instead */
  card: {
    width: 300,
    padding: 2,
    backgroundColor: 'common.white',
    borderRadius: 1,
    boxShadow: '0px 1px 4px rgba(30, 32, 38, 0.16)',
  } as SxProps<Theme>,

  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  } as SxProps<Theme>,

  iconWrapper: (bg: string): SxProps<Theme> => ({
    width: 32,
    height: 32,
    borderRadius: '50%',
    backgroundColor: bg,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  }),

  title: {
    color: 'info.main',
    typography: 'header4',
    fontStyle: 'normal',
    lineHeight: '24px',
    whiteSpace: 'nowrap',
  } as SxProps<Theme>,

  inlineInfo: {
    color: 'gray.64',
    typography: 'medium',
    fontStyle: 'normal',
    lineHeight: '20px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  } as SxProps<Theme>,

  openAlertsLink: {
    color: 'primary.main',
    typography: 'medium',
    fontStyle: 'normal',
    lineHeight: '20px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    marginLeft: 'auto',
    flexShrink: 0,
    '&:hover': {
      textDecoration: 'underline',
    },
  } as SxProps<Theme>,

  loader: {
    width: 300,
    padding: 3,
  } as SxProps<Theme>,

  loaderSkeleton2: {
    mt: 2,
  } as SxProps<Theme>,

  loaderSkeleton1: {
    mt: 1,
  } as SxProps<Theme>,
}
